import Switch from '@material-ui/core/Switch'
import { useDispatch, useSelector } from "react-redux"
import { cambiarTipoViajeClienteAction, selectClienteTarget } from "../../../ducks/clientesDuck"
import { ToastMessage } from '../../../global/ToastMessage'
import { DialogMessage } from '../../../global/DialogMessage'
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
export default function BotonTipoViaje() {
    const { cliente, referencia } = useSelector(store => store.cliente)
    const dispatch = useDispatch()
    const handleChange = (event) => {
        DialogMessage.fire({
            title: '¿Está seguro de aplicar este cambio?',
            text: (cliente?.paquete?.Internacional) ? 'Esto cambiara el paquete al tipo de viaje a nacional' : 'Esto cambiara el paquete al tipo de viaje a internacional',
            showCancelButton: true,
            confirmButtonText: "Aplicar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "" }))
                dispatch(cambiarTipoViajeClienteAction({ EsInternacional: !cliente?.paquete?.Internacional, idPaquete: cliente?.paquete?.Id_Paquete })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ocurrio un problema al actulizar el paquete",
                        })
                        return null
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "error",
                            title: Response.Message,
                        })
                        return null
                    }
                    dispatch(selectClienteTarget({ cliente, referencia }))
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }

    return (
        <div>
            <label>
                Tipo viaje
            </label>
            <Switch
                checked={cliente?.paquete?.Internacional}
                onChange={handleChange}
                name="checkedB"
                inputProps={{ 'aria-label': 'secondary checkbox' }}
            />
        </div>
    );
}